import * as d3 from 'd3'
import httpManager from "../../util/common"
import { timestampToDate } from '../../util/util'
export default {
  props: ['oaid'],
  data () {
    return {
      report_date: null,
      total_gh1_2: 0,
      empty_data_pie_show: true,
      date_year: [],
      source: '',
      loading: false,
      pie_data: [],
      colorList: ['rgb(209, 60, 75)', 'rgb(247, 136, 81)', 'rgb(253, 245, 172)', 'rgb(191, 229, 160)', 'rgb(131, 204, 165)', 'rgb(66, 136, 181)']
    }
  },
  mounted () {
    this.getReportDate()
    this.getPieData()
  },
  methods: {
    getReportDate () {
      const params = new Map()
      params.set('oaid', this.$props.oaid)
      httpManager('entity_industry_chain_date', params)
      .then(res => {
        this.date_year = res.data.data
        this.report_date = this.date_year[0]
      })
    },
    getPieData() {
      const svgDom = this.$refs.industryChainPieChart.getElementsByTagName("svg")[0]
      if (svgDom) {
        svgDom.remove()
      }
      this.loading = true
      const params = new Map()
      params.set('oaid', this.$props.oaid)
      if (!this.report_date) {
        params.set('last_year', true)
      } else {
        params.set('report_period', this.report_date)
      }
      httpManager('entity_industry_chain', params)
      .then(res => {
        const { data } = res.data
        if (data.length >= 0) {
          this.empty_data_pie_show = false
          this.pie_data.length = 0
          this.report_date = timestampToDate(data[0].report_period)
          data.forEach((item, index) => {
            this.pie_data[index] = {
              key: `${index - 1}`,
              name: item.standardized_product_name,
              value: parseFloat(item.standardized_product_revenue_percentage).toFixed(2) + '%',
              color: this.colorList[index]
            }
          });
          let width = 350/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
          let height = 500/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
          this.drawPieChar(data, {
            name: d => d.standardized_product_name,
            value: d => d.standardized_product_revenue_percentage,
            width: width,
            height: height,
            colors: this.pie_data.map(d => d.color)
          })
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.empty_data_pie_show = true
      })
    },
    drawPieChar (data,
      {
      name = ([x]) => x,
      value = ([, y]) => y,
      title,
      width = 640,
      height = 400,
      innerRadius = 0,
      outerRadius = Math.min(width, height) / 3,
      labelRadius = (innerRadius * 0.2 + outerRadius * 0.8),
      format = ",",
      names,
      colors,
      stroke = innerRadius > 0 ? "none" : "white",
      strokeWidth = 1,
      strokeLinejoin = "round",
      padAngle = stroke === "none" ? 1 / outerRadius : 0,
      fontsize = 10
    } = {}) {
      d3.select("#esg_rating_line_chart").select('*').remove()
      // Compute values.
      const N = d3.map(data, name);
      const V = d3.map(data, value);
      const I = d3.range(N.length).filter(i => !isNaN(V[i]));

      // Unique the names.
      if (names === undefined) names = N;
      names = new d3.InternSet(names);

      // Chose a default color scheme based on cardinality.
      if (colors === undefined) colors = d3.schemeSpectral[names.size];
      if (colors === undefined) colors = d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), names.size);

      // Construct scales.
      const color = d3.scaleOrdinal(names, colors);

      // Compute titles.
      if (title === undefined) {
        const formatValue = d3.format(format);
        title = i => `${N[i]}\n${formatValue(V[i])}`;
      } else {
        const O = d3.map(data, d => d);
        const T = title;
        title = i => T(O[i], i, data);
      }

      // Construct arcs.
      const arcs = d3.pie().padAngle(padAngle).sort(null).value(i => V[i])(I);
      const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
      const arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius);

      const svg = d3.select('#entity-industry-chain')
        .append('svg')
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", [-width / 2, -height / 2, width, height])
        .attr("style", "max-width: 100%; height: auto; height: intrinsic;");
        svg.append("g")
        .attr("stroke", stroke)
        .attr("stroke-width", strokeWidth)
        .attr("stroke-linejoin", strokeLinejoin)
      .selectAll("path")
      .data(arcs)
        .join("path")
        .attr("fill", d => color(N[d.data]))
        .attr("d", arc)
      .append("title")
        .text(d => title(d.data));
        svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .attr("text-anchor", "middle")
      .selectAll("text")
      .data(arcs)
      .join("text")
        .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
      .selectAll("tspan")
      .data(d => {
        const lines = `${title(d.data)}`.split(/\n/);
        return lines.slice(1, 2);
      })
      .join("tspan")
        .attr("x", 0)
        .attr("y", (_, i) => `${i * 1}em`)
        .attr("font-weight", (_, i) => i ? null : "bold")
        .text(d =>
          parseFloat(d)>3?parseFloat(d).toFixed(2) + '%':''
        )
      return Object.assign(svg.node(), {scales: {color}});
    }
  },
}



// WEBPACK FOOTER //
// ./src/entity/js/entity_industry_chain.js